"use client";
import { useAtomValue, useSetAtom } from "jotai";
import { ReactNode, useEffect, useMemo, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { CartIcon } from "../icons/CartIcon";
import { isMobileAtom, toolkitAtom } from "../store/layoutStore";
import useCart from "../store/useCart";
import { defaultTheme } from "../styles/defaultTheme";
import { FlexRow, Fonts } from "../styles/globalsStyles";
import CartDrawer from "./CartDrawer";

const CartTimerLeft = () => {
  const { timeLeft } = useCart();
  const setToolkit = useSetAtom(toolkitAtom);
  const isMobile = useAtomValue(isMobileAtom);
  useEffect(() => {
    if (!timeLeft) {
      setToolkit(null);
      return;
    }
    setToolkit({
      jsx: <TimerJsx>{timeLeft}</TimerJsx>,
      options: { notToCenterX: true }
    });
    return () => setToolkit(null);
  }, [isMobile, setToolkit, timeLeft]);

  return null;
};

const TimerJsx = ({ children }: { children: ReactNode }) => {
  const [toShowCartDrawer, setToShowCartDrawer] = useState(false);
  // Check if timeLeft is below one minute
  const isBelowOneMinute = useMemo(
    () =>
      typeof children === "string" && parseInt(children.split(":")[0]) === 0,
    [children]
  );

  return (
    <>
      <FlexRow
        $justifyContent="center"
        $alignItems="center"
        $gap={".5rem"}
        onClick={() => setToShowCartDrawer((state) => !state)}
      >
        <CartIcon
          stroke={isBelowOneMinute ? "red" : defaultTheme.primaryColor}
          width={24}
          height={24}
        />
        <TimeItselfWrap $isBelowOneMinute={isBelowOneMinute}>
          {children}
        </TimeItselfWrap>
      </FlexRow>
      <CartDrawer
        setToShow={setToShowCartDrawer}
        toShow={toShowCartDrawer}
        side="right"
      />
    </>
  );
};

// Define keyframes for the vibration effect
const vibrate = keyframes`
  0% { transform: translate(0); }
  20% { transform: translate(-2px, 2px); }
  40% { transform: translate(-2px, -2px); }
  60% { transform: translate(2px, 2px); }
  80% { transform: translate(2px, -2px); }
  100% { transform: translate(0); }
`;

const TimeItselfWrap = styled.div<{ $isBelowOneMinute?: boolean }>`
  cursor: pointer;
  /* width: 300px; */
  color: red;
  ${Fonts.medium}
  font-weight: bold;

  ${({ $isBelowOneMinute }) =>
    $isBelowOneMinute &&
    css`
      animation: ${vibrate} 0.5s linear infinite;
    `}
`;

export default CartTimerLeft;
